export default {
  nav: {
    product: 'Product',
    product2: 'Home',
    tutorial: 'Download & Tutorial',
    advantage: 'Advantage',
    userInstance: 'User Instance',
    productScheme: 'Product Scheme',
    pay: 'Payment',
    account: 'Account',
    login: 'Login',
    register: 'Free Register',
    logout: 'Logout',
    wechat: 'WeChat',
    wsService: 'WS Service',
    privateMessage: 'Private Message',
    about: 'About Us',
  },
  common: {
    welcome: 'Welcome',
    home: 'Home',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    // Logout dialog
    logoutTitle: 'Logout',
    logoutMessage: 'Are you sure you want to logout?',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    // Login expired
    loginExpired: 'Login session has expired, please login again',
    reLogin: 'Re-login',
    // Security check (Cloudflare challenge)
    securityCheckExpired: 'Security verification has expired, please refresh the page to verify again',
    refreshPage: 'Refresh page',
  },
  logout: {
    processing: 'Logging out...',
    success: 'Logout successful',
    failed: 'Logout failed',
  },
  homeHero: {
    titlePrefix: 'TranGPT - ',
    titleHighlight: 'Drive stronger sales performance',
    descLine1: '180+ language translation, document translation, real-time voice synthesis, RESTful API integration',
    descLine2Prefix: 'A one-stop ',
    descLine2Highlight: 'multilingual solution',
    descLine2Suffix: ' for cross-border e-commerce, foreign trade, and global businesses',
    cta: 'Start Free',
  },
  contactBanner: {
    officialContact: 'Official Contact',
    officialEmail: 'Official Email',
  },
  // Product Page
  product: {
    title: "TranGPT cannot replace customer development\nBut with TranGPT you'll develop customers faster\nMust-have AI customer service system for top sellers",
    description: 'Support translation in 120 countries and regions, making your consultation borderless!',
    tryNow: 'Try Now',
    downloadNow: 'Download Now',
    consultDiscount: 'Consult for Discount',
    multiApp: 'Multiple Apps, One Client Solution',
    userManagement: 'User Management Made Easy',
    multiAccount: 'Multiple Accounts Online Simultaneously',
    clientMultiOpen: 'Client Multi-Open',
    support120Languages: 'Support 120+ Languages Accurate Translation',
    realTimeTranslation: 'Support Real-time Translation, Zero Errors',
    bidirectionalTranslation: 'Bidirectional Translation, No Mistakes',
    aiOptimization: 'AI Optimization, Real Voice Cloning',
    userTrust: 'User Trust',
    stableReliable: 'Stable and Reliable',
    grabOpportunity: 'Seize Every Sales Opportunity',
    whyUsingTranGPT: 'Why Everyone Uses TranGPT',
    whatsappSolution: 'WhatsApp Overseas Solution',
    whatsappDesc: 'Provide excellent customer service and unlock sales opportunities directly through our unified backend.',
    facebookTool: 'Facebook Smart Service Tool',
    facebookDesc: 'Provide excellent customer service and unlock sales opportunities. Unified management of all social media messages, using Facebook integration to batch link multiple pages to save time and manpower.',
    communicationPlatform: 'Communication Platform for All Sellers',
    windowsDownload: 'Windows Download',
    win64: '(64-bit)',
    win7Version: '(Win7 Version)',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial',
    productManager: 'Product Manager',
    userReview: 'With its powerful fine-tuning model, AI art becomes effortless. Let me discover the best community!',
    // Product2 Page Additional Fields
    supportGlobal: 'Support global 20+ software real-time translation and AI assistance',
    oneEndMultiOpen: 'One-end multi-open, no additional software needed',
    voiceClone: 'Real voice cloning, no worries about voice',
    speechOptimization: 'Speech optimization, supports AI optimization for different cultural scenarios',
    aiModelIntegration: 'Integrated with major AI models, use with confidence',
    ourPromise: 'Our Promise',
    securityEncryption: 'Security Encryption',
    globalTopEncryption: '· Global top encryption technology',
    serverMultiEncryption: '· Multi-layer server encryption',
    privacyDataSecurity: '· Guarantee privacy and data security',
    industryLeadingProtocol: '· Industry-leading encryption transmission protocol',
    languageExpertGuarantee: '· Language expert guarantee for language translation',
    translate100kWords: '· Translate 100,000 words without interruption or errors',
    serve100kUsers: '· Serving 100,000+ users worldwide',
    uniqueVoiceClone: '· Unique voice cloning, users can rest assured',
    techEnterpriseSupport: '· Backed by tech enterprises, stable and reliable',
    globalTopAI: '· Integrated with global top AI models',
    customizableFeatures: '· Customizable features on demand',
    onlineNoLag: '· Online simultaneously without lag',
    macDownload: 'Mac Download',
    appleChip: '(Apple Silicon, M-series, 2020+ models)',
    intelChip: '(Intel Chip, pre-2020 models)',
    appleChipHint: 'Mac from the last 5 years (most common)',
    intelChipHint: 'Mac older than 5 years (less common)',
    recommended: 'Recommended',
    communicationPlatformDesc: 'Using voice cloning and AI assistance to comprehensively improve sales performance and customer satisfaction.',
    productManagerRole: 'Product Manager',
    userReview2: 'With its powerful fine-tuning model, AI art becomes effortless. Let me discover the best community!',
    // Product2 Page User Review Section
    globalSoftwareSupport: 'Support global 20+ software real-time translation and AI assistance',
    productManagerTitle: 'Product Manager',
    userTestimonial: 'With its powerful fine-tuning model, AI art becomes effortless. Let me discover the best community!'
  },
  // Login Page
  login: {
    title: 'Member Login',
    email: 'Email',
    password: 'Password',
    rememberPassword: 'Remember Password',
    forgotPassword: 'Forgot Password',
    loginBtn: 'Login',
    agreeTerms: 'By registering, you agree to',
    serviceAgreement: 'Service Agreement',
    privacyPolicy: 'Privacy Policy',
    noAccount: 'No account?',
    goRegister: 'Sign Up',
    // New message prompts
    logging: 'Logging in...',
    pleaseEnterEmailAndPassword: 'Please enter email and password',
    loginFailed: 'Login failed',
    loginError: 'Login error, please try again later',
    loginSuccess: 'Login successful! Redirecting to account center...',
  },
  // Reset Password Page
  resetPassword: {
    title: 'Reset Password',
    step1Title: 'Enter Email Address',
    step2Title: 'Set New Password',
    emailLabel: 'Email Address',
    emailPlaceholder: 'Please enter your email address',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Please enter new password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please confirm new password',
    resetPassword: 'Reset Password',
    resetting: 'Resetting...',
    backToLogin: 'Back to Login',
    linkSent: 'Reset link has been sent to your email. Please click the link in the email to complete password reset.',
    linkSentSuccess: 'Reset password link has been sent to your email. Please complete password reset within 30 minutes. If you don\'t receive the email, please check your spam folder.',
    checkSpamFolder: 'If you don\'t receive the email, please check your spam folder. If you still don\'t receive it, please try resending or contact customer support.',
    captchaError: 'Captcha verification failed, please try again',
    captchaExpired: 'Captcha has expired, please verify again',
    resendCountdown: 'Resend ({seconds}s)',
    resetSuccess: 'Password reset successfully, redirecting to login page',
    sendLinkError: 'Failed to send reset link, please try again',
    resetError: 'Failed to reset password, please try again',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordTooLong: 'Password cannot exceed 32 characters',
    passwordNeedLowercase: 'Password must contain lowercase letters',
    passwordNeedUppercase: 'Password must contain uppercase letters',
    passwordNeedNumber: 'Password must contain numbers',
    passwordMismatch: 'Passwords do not match',
    invalidToken: 'Reset link is invalid or expired, please request a new one',
    tokenRequired: 'Reset token is missing, please access this page through the email link',
    pleaseEnterEmail: 'Please enter your email address',
    invalidEmail: 'Please enter a valid email address',
    passwordValidationError: 'Password format does not meet requirements'
  },
  // Register Page
  register: {
    title: 'Register Account',
    username: 'Enter Username',
    password: 'Enter Password',
    email: 'Email',
    verificationCode: 'Verification Code',
    getCode: 'Get Code',
    invitationCode: 'Invitation Code (Optional)',
    teamSizePlaceholder: 'Select Team Size (Optional)',
    contactTypePlaceholder: 'Select Contact Type',
    contactPlaceholder: 'Enter Contact Info (Optional)',
    registerBtn: 'Register',
    agreeTerms: 'By registering, you agree to',
    serviceAgreement: 'Service Agreement',
    privacyPolicy: 'Privacy Policy',
    hasAccount: 'Already have an account?',
    goLogin: 'Sign In',
    // New message prompts
    emailRequired: 'Please enter your email address',
    codeSending: 'Sending...',
    codeSent: 'Verification code has been sent to your email',
    codeSendFailed: 'Failed to send verification code',
    allFieldsRequired: 'Please fill in all required fields',
    registering: 'Registering...',
    registerSuccess: 'Registration successful! Redirecting to login page...',
    registerFailed: 'Registration failed',
    captchaError: 'Captcha verification failed, please try again',
    captchaExpired: 'Captcha has expired, please verify again',
    teamSizeOptions: {
      "1to10": '1-10',
      "10to20": '10-20',
      "20to50": '20-50',
      "50to100": '50-100',
      "100plus": '100+',
    },
    contactTypes: {
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      wechat: 'WeChat',
    },
  },
  // Footer Component
  footer: {
    slogan: 'Striving to Integrate Technology and Language',
    description: 'Continuously breaking technical boundaries, innovative solutions meet changing market demands',
    functionIntro: 'Function Introduction',
    tutorial: 'Tutorial',
    purchaseRecord: 'Purchase Record',
    wechatService: 'WeChat QR Code Customer Service',
    copyright: 'TranGPT © COPYRIGHT 2018-2023 ALL RIGHTS RESERVED.',
    companyInfo: 'Copyright © Mohist AI Systems Limited  Contact: contact@trangpt.ai'
  },

  // Pay Page
  pay: {
    title: 'Recharge Center',
    packageRecharge: 'Package Recharge',
    supportPayment: 'Support USDT-TRC20 Network & Stripe Credit Card Payment',
    packageQuantity: 'Yu Fu Package and Purchase Quantity',
    orderAmount: 'Order Amount',
    payableAmount: 'Payable Amount:',
    paymentMethod: 'Payment Method',
    usdtPayment: 'USDT-TRC20 (Only supports USDT-TRC20 network)',
    stripePayment: 'Stripe Payment (Supports credit/debit cards)',
    copyAddress: 'Copy Address',
    addressCopied: 'Address copied to clipboard',
    nextStep: 'Next Step',
    notice: 'Note: Payment amount must be exactly the same, otherwise the order is invalid',
    usdtOption: 'USDT-TRC20 (Only USDT-TRC20 network supported)',
    stripeOption: 'Stripe Payment (Credit/Debit Cards Supported)',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial',
    // Countdown related
    paymentCountdown: 'Payment Countdown',
    remainingTime: 'Remaining Time',
    paymentInstructions: 'Please complete payment within the specified time, orders will automatically expire after timeout',
    paymentExpired: 'Payment time has expired',
    paymentExpiredMessage: 'Payment time has expired, please initiate payment again'
  },

  // ProductScheme Page
  productScheme: {
    quarterlyPackage: 'Quarterly Package',
    quarterlyPlan: 'Quarterly Package',
    deepLChatGPT: 'DEEPL+CHATGPT',
    deeplChatgpt: 'DEEPL+CHATGPT',
    buyNow: 'Buy Now',
    unlimitedChars: 'Unlimited character usage, unlimited login ports',
    unlimitedTime: "No restrictions on usage time No restrictions on creating sub-accounts",
    ipConfig: 'Support account IP configuration',
    fingerprint: 'Account fingerprint environment isolation',
    aiReply: 'AI automatic reply, AI sidebar Q&A',
    millionChars: '10M Characters',
    chars200w: '3.75M Characters',
    chars1000w: '18.8M Characters',
    chars15000w: '150M Characters',
    flagshipPlan: 'Flagship Plan',
    monthlyPlan: 'Monthly Plan',
    singleUserOnly: 'Single-user edition, no sub-accounts',
    portCustomTitle: 'Custom',
    portCustomUnit: 'Port Plan',
    portPriceFrom: 'From 40 USDT',
    contactForDetails: 'Contact us for details',
    portFeature1: 'Custom port provisioning with ticket counters & chat progress tracking',
    portFeature2: '100+ ports per order, from 8 USDT/port, best pricing',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial',
    bannerFeatureTranslate: '180+ language text translation',
    bannerFeatureTerminology: 'Custom terminology database',
    bannerFeatureTts: 'High-naturalness text-to-speech (TTS)',
    bannerFeatureVoiceTranslate: 'Real-time voice translation',
    bannerFeatureTeam: 'Team collaboration features',
    bannerFeatureDocument: 'Multi-format document translation',
    bannerTitle: 'Pricing Plan',
    bannerDesc1: 'In the era of globalization, communication with European and American customers is crucial. But cultural and language differences are often the biggest challenge.',
    bannerDesc2: 'Now we introduce the new-generation overseas customer service system — TranGPT, delivering the most authentic and natural communication experience for you!'
  },
  // Advantage Page
  advantage: {
    threeAdvantages: '3 distinctive advantages',
    bannerTitle: 'Industry Advantages',
    bannerDesc: 'AI efficient and concise translation, aggregates global mainstream social apps, enables bidirectional translation',
    cooperateWith200Companies: 'Cooperated with 200+ companies to make overseas communication easier',
    chooseTranGPTSimple: 'Choosing TranGPT is simple',
    title1: 'Achieve millisecond-level efficient translation using TRANGPT4 to meet customers sensory needs',
    realTime: 'Real-time/REAL TIME',
    realTimeDesc1: 'Personalized translation',
    realTimeDesc2: 'Tone modification and optimization',
    realTimeDesc3: 'AI generates replies based on customer chat content',
    efficient: 'Efficient/HIGHLY EFFICIENT',
    efficientDesc1: 'Customize scenarios and chat tone',
    efficientDesc2: 'Automatically generate replies based on context',
    efficientDesc3: 'Instantly respond to various professional customer questions',
    accurate: 'Accurate/ACCURATE',
    accurateDesc1: 'TranGPT natural language translation',
    accurateDesc2: 'AI intelligent customer service system',
    accurateDesc3: 'Communication experience close to speakers habits',
    title2: 'Achieve millisecond-level efficient translation using TRANGPT4 to meet customers sensory needs',
    convenient: 'Convenient and Easy',
    convenientDesc1: 'Simple operation',
    convenientDesc2: 'Easy to get started from download',
    multiLanguage: 'Multi-language Support',
    multiLanguageDesc1: 'Excellent development team',
    multiLanguageDesc2: 'Ultimate attention to detail design',
    globalCoverage: 'Global Coverage',
    globalCoverageDesc1: 'Simple operation',
    globalCoverageDesc2: 'Easy to get started from download',
    professionalTranslation: 'Professional Translation',
    professionalTranslationDesc1: 'Multiple encryption',
    professionalTranslationDesc2: 'Independent deployment, complete data isolation',
    intelligentRecognition: 'Intelligent Recognition',
    aiIntelligence: 'AI Intelligence',
    deepLearning: 'Deep Learning',
    continuousOptimization: 'Continuous Optimization',
    personalizedService: 'Personalized Service',
    revolutionaryDesc: 'TranGPT is a social application based on artificial intelligence technology that can efficiently and concisely implement translation functions. Through the use of machine learning technology, TranGPT can automatically learn languages and cultures to achieve accurate translation. TranGPT can also use natural language processing technology to identify and understand users language and cultural backgrounds, thereby providing more accurate translation results.',
    socialManagementDesc: 'TranGPT aggregates mainstream social applications around the world, including Facebook, Twitter, Instagram, etc., and also implements bidirectional translation functions. Users can communicate with other users by inputting text or images. TranGPT also provides interfaces for various social applications, making it easy to communicate and interact with other users. It also has automatic error correction and automatic punctuation functions to help users better understand and use language.',
    aiAssistantDesc: 'TranGPT also provides intelligent assistant functions that can help users complete various tasks and operations. At the same time, intelligent assistants can also help provide information, answer questions, execute tasks and other operations. It uses deep learning algorithms and natural language processing technology to quickly and accurately identify and translate text and images in different languages. TranGPT AI efficient and concise translation function supports multiple text types, including news, emails, social media, etc. It can automatically identify important information in text and translate it into corresponding languages.',
    personalizationDesc: 'Translation Attention Profiling (TAP): TranGPT can analyze and predict the relationships between different languages, such as grammar, semantics, emotions, etc., by learning a large amount of text, thereby achieving more personalized and accurate translation. 12 major universities are developing products with similar functions or technologies to TranGPT. 13 TranGPT AI efficient and concise translation function is a brand new technology with great prospects and can be applied to many fields, including machine translation, etc. 14 TranGPT deep personalization service is a deep customization service that can be customized and optimized according to different user needs to meet different user requirements.',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial'
  },
  // Account page
  account: {
    title: 'Account Center',
    accountHome: 'Account Home',
    orderManagement: 'Order Management',
    changePassword: 'Change Password',
    changeEmail: 'Change Email',
    changeUsername: 'Change Username',
    packageList: 'Package List',
    orderList: 'Order Management',
    packageInfo: 'Package Information',
    noPackage: 'No package information available',
    number: 'Number',
    type: 'Type',
    quantity: 'Quantity',
    port: 'Port',
    status: 'Status',
    validTime: 'Valid Time',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    oldPasswordPlaceholder: 'Please enter old password',
    newPasswordPlaceholder: 'Please enter new password',
    confirmPasswordPlaceholder: 'Please confirm new password',
    changePasswordBtn: 'Change Password',
    currentPassword: 'Current Password',
    newEmail: 'New Email',
    currentPasswordPlaceholder: 'Please enter current password',
    newEmailPlaceholder: 'Please enter new email',
    changeEmailBtn: 'Change Email',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial',
    packageTypes: {
      character: 'Character Package',
      monthly: 'Monthly Package',
      daily: 'Daily Package',
      port: 'Port Package',
      other: 'Other Package',
    },
    packageStatus: {
      unused: 'Unused',
      using: 'Using',
      expired: 'Expired',
      unknown: 'Unknown',
    },
    changing: 'Changing...',
    verificationCode: 'Verification Code',
    verificationPlaceholder: 'Please enter verification code',
    getVerificationCode: 'Get Code',
    sendCodeSuccess: 'Verification code sent to your new email',
    sendCodeFailed: 'Failed to send verification code',
    sendCodeFailedRetry: 'Failed to send verification code, please try again later',
    fetchOrderDetailFailed: 'Failed to fetch order details, please try again later',
    fetchUserInfoFailed: 'Failed to fetch user info, please try again later',
    passwordRequired: 'Please enter password',
    passwordLength: 'Password length must be 8-32 characters',
    passwordComplexity: 'Password must include uppercase, lowercase letters and numbers',
    oldPasswordRequired: 'Please enter old password',
    confirmPasswordRequired: 'Please confirm new password',
    passwordsNotMatch: 'Passwords do not match',
    passwordChangeSuccess: 'Password changed successfully, redirecting to login.',
    passwordChangeFailed: 'Failed to change password, please try again later',
    newEmailRequired: 'Please enter new email address',
    newEmailInvalid: 'Please enter a valid email address',
    verificationCodeRequired: 'Please enter verification code',
    emailChangeSuccess: 'Email updated successfully!',
    emailChangeFailed: 'Email update failed',
    emailChangeFailedRetry: 'Failed to change email, please try again later',
    newUsername: 'New Username',
    newUsernamePlaceholder: 'Please enter a new username',
    changeUsernameBtn: 'Save',
    usernameRequired: 'Please enter a username',
    usernameTooLong: 'Username cannot exceed 80 characters',
    usernameChangeSuccess: 'Username updated successfully!',
    usernameChangeFailed: 'Username update failed',
    usernameChangeFailedRetry: 'Failed to change username, please try again later',

    // Order Status
    orderStatus: {
      pending: 'Pending Payment',
      reviewing: 'Under Review',
      approved: 'Approved',
      rejected: 'Rejected',
      expired: 'Expired',
      refunded: 'Refunded',
      unknown: 'Unknown Status'
    },

     // Order Management Interface
     orderFilter: {
       all: 'All Orders',
       pending: 'Pending Payment'
     },

     orderTable: {
       orderNo: 'Order No.',
       date: 'Date',
       type: 'Type',
       quantity: 'Quantity',
       amount: 'Order Amount',
       status: 'Order Status',
       operation: 'Operation',
       detail: 'Detail',
       loading: 'Loading...',
        noData: 'No order data available',
      },

    pagination: {
      previous: 'Previous',
      next: 'Next',
      pageInfo: 'Page {current} of {total}'
    }
    ,
    orderDetail: {
      title: 'Order Detail',
      orderNo: 'Order No.',
      name: 'Package Name',
      quantity: 'Quantity',
      price: 'Price',
      payment: 'Payment',
      orderTime: 'Order Time',
      status: 'Status'
    }
  },
   // Tutorial page
   tutorial: {
    startNewExperience: 'Start a new experience from download',
    registerExclusiveAccount: 'Register your exclusive account',
    loginStartJourney: 'Login to start a new journey',
    setToChinese: 'Simply set to Chinese',
    startBarrierFreeCommunication: 'Click to start barrier-free communication',
    clearerVideoGuide: 'Clearer video guide',
    step1Title: 'Click any button on the official website to download TRANGPTT and install it.',
    step1Desc: 'Download and install the TranGPT application',
     macDownload: 'Mac Download',
     appleChip: '(Apple Silicon, M-series, 2020+ models)',
     intelChip: '(Intel Chip, pre-2020 models)',
     appleChipHint: 'Mac from the last 5 years (most common)',
     intelChipHint: 'Mac older than 5 years (less common)',
     recommended: 'Recommended',
     windowsDownload: 'Windows Download',
     win64: '(Win64-bit)',
     win7Version: '(Win7 Version)',
     step2Title: 'Enter your personal information to start registration. Email must be a real email address, we are afraid we cannot contact you.',
     step2Desc: 'Register and log in to your account',
     step3Title: 'Log in to your account, you can translate in real time while chatting. Start your journey of connecting with the world~',
     step3Desc: 'Select the translation language you need',
     step4Title: 'Log in to your account, you can translate in real time while chatting. Start your journey of connecting with the world~',
     step4Desc: 'Log in to your account and enjoy real-time translation while chatting. Start your journey of connecting with the world!',
     step5Title: 'Come and start your experience! If you need further information, please do not hesitate to contact us, we are happy to serve you!',
     step5Desc: 'Start enjoying real-time translation services',
     step6Title: 'Come and start your experience! If you need further information, please do not hesitate to contact us, we are happy to serve you!',
     step6Desc: 'Come and start your experience! If you need further information, please do not hesitate to contact us. We are happy to serve you!',
     contactConsultant: 'Contact Your Dedicated Consultant Now',
     contactAdvisor: 'Contact Your Dedicated Advisor Now',
     telegramConsult: 'Telegram Customer Service Free Trial'
   },
   // Product page (Original)
   productOriginal: {
    alwaysByYourSide: 'Whatever you need, TranGPT is always by your side',
    efficientConvenientFast: 'Efficient, Convenient and Fast',
    support180Countries: 'Support 180+ countries and regions language translation for borderless communication',
    newArchitecture: 'New Architecture, Ultimate Stability',
    encryptionSecurity: 'Encryption Protection, Ultimate Security',
    independentIP: 'Independent IP Setting for Sessions',
    multiLanguage: 'Multi-language Real-time Bidirectional Translation',
     aiTitle: 'Artificial Intelligence',
     languageSupport: 'Extensive Language Support',
     languageSupportDesc: 'TranGPT supports translation of multiple languages, including but not limited to English, Chinese, Japanese, French, German, Spanish, etc., covering most languages used globally.',
     fastTranslation: 'Fast and Accurate Translation',
     fastTranslationDesc: 'TranGPT can quickly and accurately translate various texts through deep learning technology, including news reports, business documents, emails, travel materials, etc.',
     autoMemory: 'Automatic Memory Update',
     autoMemoryDesc: 'TranGPT has automatic memory update function, which can automatically optimize translation results according to user usage habits, improving translation accuracy and fluency.',
     multiFormat: 'Multiple Output Formats',
     multiFormatDesc: 'TranGPT supports multiple output formats, such as text, PDF, images, etc., making it convenient for users to choose according to their needs.',
     socialManagementTitle: 'One-stop Overseas Social Management',
     fastSpeed: 'Fast Speed',
     fastSpeedDesc: 'TranGPT has high efficiency and can complete translation of multiple languages in a short time. This makes translation work more convenient and efficient.',
     highQuality: 'High Quality',
     highQualityDesc: 'Using advanced artificial intelligence technology, it can identify problems in grammar, vocabulary, and tone in language, thereby improving translation quality.',
     easyToUse: 'Easy to Use',
     easyToUseDesc: 'The translation function is simple and easy to use, users can easily set parameters and adjust translation quality. This makes the user experience more friendly.',
     scalable: 'Highly Scalable',
     scalableDesc: 'TranGPT with its fast and concise, high quality, easy to use and highly scalable features, provides users with a more convenient, efficient and friendly translation experience.',
     socialManagement: 'Social Management',
     socialManagementDesc: 'RANGPT artificial intelligence AI efficient and concise translation function can also help users manage their accounts, messages, fans and other information on social platforms.',
     personalizationTitle: 'Deep Personalized Service',
     translationFunction: 'Translation Function',
     translationFunctionDesc: 'Artificial intelligence AI has powerful translation functions that can help users quickly and accurately translate multiple languages.',
     grammarCheck: 'Grammar Check',
     grammarCheckDesc: 'Artificial intelligence AI supports grammar check function, which can help users check and correct English grammar errors. It can detect grammar errors in sentences and provide corresponding modification suggestions.',
     termManagement: 'Term Management',
     terminologyManagementDesc: 'Artificial intelligence AI also has term management function, which can help users extract terms from translation results so that users can better understand and use them.',
     multiLanguageSupport: 'Multi-language Support',
     multiLanguageSupportDesc: 'Artificial intelligence AI also supports multi-language support, which can automatically recognize and translate sentences and words in multiple languages.',
     bilingualDictionary: 'Bilingual Dictionary',
     bilingualDictionaryDesc: 'Artificial intelligence AI also supports bilingual dictionary function, which can automatically merge words and phrases in two different languages into one language.',
     trangpt4Description: 'Using TRANGPT4 to achieve millisecond-level efficient translation, meeting customers sensory needs.',
     commonProblems: 'Common problems in life: Lack of systematic understanding of the laws governing things can easily lead to confusion in handling routine affairs. When environmental interference factors become complex, emotional control failure will weaken the ability to handle problems?',
     aiResponse: 'Common problems in life: Lack of systematic understanding of the laws governing things can easily lead to confusion in handling routine',
     systemSupport: 'The system supports multi-language interface and real-time translation, instantly converting customer conversations, so you dont have to worry about language barriers.',
     coreAdvantagesTitle: 'Core Advantages',
     coreAdvantageGptTitle: 'More accurate GPT-powered translation',
     coreAdvantageGptDesc: 'Deeply fine-tuned on GPT architecture, with stronger context understanding for long sentences and professional terminology.',
     coreAdvantageLanguageTitle: '180+ language coverage',
     coreAdvantageLanguageDesc: 'Covers mainstream global languages and niche languages, far beyond similar tools.',
     coreAdvantageTtsTitle: 'Translation + TTS integration',
     coreAdvantageTtsDesc: 'Turn translated text into natural voice in one click for customer service, livestreaming, and education.',
     coreAdvantageSecurityTitle: 'Stable local access + compliance security',
     coreAdvantageSecurityDesc: 'No VPN required, enterprise-grade privacy protection, and data stays compliant.',
     suitableForTitle: 'Who It Is For',
     audienceCrossBorderSeller: 'Cross-border E-commerce Sellers',
     audienceTradeSales: 'Foreign Trade Sales',
     audienceBrandOperation: 'Global Brand Operations',
     audienceDeveloperIntegration: 'Developers / Technical Integration',
     audienceSupportTeam: 'Multilingual Support Teams',
     audienceConferenceLive: 'International Meetings / Livestreams',
     contactAdvisor: 'Contact Your Dedicated Advisor Now',
     contactConsultant: 'Contact Your Dedicated Consultant Now',
     telegramConsult: 'Telegram Customer Service Free Trial',
     socialTitle: 'Social Title',
     personalizedService: 'Deep Personalized Service',
     terminologyManagement: 'Terminology Management'
   },
   // UserInstance page
  userInstance: {
    userFeedback: 'User Feedback',
    title: 'User Instance',
     instanceList: 'Instance List',
     createInstance: 'Create Instance',
     instanceName: 'Instance Name',
     instanceType: 'Instance Type',
     status: 'Status',
     createTime: 'Create Time',
     operation: 'Operation',
     start: 'Start',
     stop: 'Stop',
     delete: 'Delete',
     edit: 'Edit',
     running: 'Running',
     stopped: 'Stopped',
     pending: 'Pending',
     contactAdvisor: 'Contact Your Dedicated Advisor Now',
     telegramConsult: 'Telegram Customer Service Free Trial',
    description: 'The system supports multi-language interface and real-time translation, instantly converting customer conversations, so you don\'t have to worry about language barriers.',
    contactConsultant: 'Contact Your Dedicated Advisor Now',
    bannerTitle: 'User Case Studies',
    bannerDesc1: 'Provide reference screenshots from other users for your review.',
    bannerDesc2: 'Highlight our product advantages while offering usage references. Using ChatGPT 5.0 to achieve millisecond-level efficient translation to meet customers\' sensory needs.',
     users: [
       {
         name: 'Sun Sida',
         company: 'Hunan Dingtu Interactive Company',
         testimonial: 'This TranGPT artificial intelligence AI efficient and concise translation function is really great! It translated my chat records into 99+ languages, and real-time chat translation, communicating with customers like native speakers.'
       },
       {
         name: 'Zhou Xiaoyi',
         company: 'Shanghai Jingdingxuan Company',
         testimonial: 'It can help users complete tasks faster and save time and energy. Its translation speed is very fast and accurate. Users can use it to quickly complete daily tasks such as document translation, email replies, etc. This tool is very suitable for tasks that require fast translation or processing large amounts of data, such as education, medical, finance and other fields.'
       },
       {
         name: 'Zhao Yufeng',
         company: 'Hubei Jinhu Hong Kong Style Company',
         testimonial: 'This software also supports automatic real-time translation for mainstream instant messaging software such as INSTAGRAM, FACEBOOK, LINE TELEGRAM, allowing me to communicate with friends anytime, anywhere. It can also help me quickly translate emails, saving me a lot of time on email replies, and the translation is very accurate!'
       },
       {
         name: 'Wu Xuanxuan',
         company: 'Jiangsu Feisuo Company',
         testimonial: 'I am very satisfied with its translation effect, with high accuracy. Its functions are very practical, allowing me to easily translate from one language to another.'
       },
       {
         name: 'Zheng Tingya',
         company: 'Tianjin Novozymes Company',
         testimonial: 'Using TranGPT artificial intelligence AI efficient and concise translation function is very convenient, no need to write any code, and no training data is required. The quality of translation results is also very high, whether it is English or other languages. I really like this tool because it can help me quickly understand the meaning in a language.'
       },
       {
         name: 'Feng Sichai',
         company: 'Guangdong Sirui Company',
         testimonial: 'It has given me great help and surprises. It can also quickly and accurately translate large amounts of text, which is very suitable for writers like me. It can also help me quickly translate and proofread large amounts of text, which is very useful for writing articles.'
       }
     ]
   },

   registerSuccess: {
    title: 'Registration Successful!',
    message: 'Congratulations on successfully registering your TranGPT account. You can now start experiencing our services.',
    welcomeMessage: 'Welcome to TranGPT!',
    goToLogin: 'Login Now',
    goToHome: 'Back to Home',
    autoRedirect: 'Automatically redirecting to login page in {seconds} seconds'
  },

  about: {
    aboutCompany: 'About Mohist AI Limited',
    companyDescription: 'Mohist AI Limited is headquartered in Hong Kong and is a high-tech enterprise focused on artificial intelligence (AI), big data, cloud computing, and the Internet of Things (IoT). We are committed to providing digital transformation solutions for global enterprises. With the mission of "empowering the commercial future through technology," we help clients improve efficiency, optimize experiences, and explore new growth paths through innovative technology. The company leverages Hong Kong\'s global network to expand its business across Asia and the world.',
    aboutTranGPT: 'About TranGPT',
    trangptDescription: 'TranGPT is an AI-powered multilingual translation and text-to-speech (TTS) Software as a Service (SaaS) platform. Designed specifically for cross-border e-commerce, international finance, and global business, TranGPT redefines real-time communication by providing enterprise-grade translation accuracy and human-like speech synthesis in a secure, scalable environment. TranGPT aims to provide fast, accurate, and culturally adaptive communication solutions for cross-border e-commerce sellers, financial professionals, and international enterprises.',
    contactUs: 'Contact Us',
    contactDescription: 'For more information and community updates, please join the official TranGPT channels',
    telegramEnglish: 'Telegram (English)',
    telegramChinese: 'Telegram (Chinese)',
    telegramSupport: 'Telegram (Customer Support)',
    whatsappSupport: 'WhatsApp Support',
    contactAdvisor: 'Contact Your Dedicated Advisor Now',
    telegramConsult: 'Telegram Customer Service Free Trial'
  },
  terms: {
    pageTitle: 'Service Agreement',
    updatedAt: 'Last updated: September 8, 2026',
    intro:
      'Welcome to TranGPT ("the Platform", "we", "us"). This Service Agreement ("Agreement") is entered into between you ("User", "you") and Mohist AI Limited, and governs your registration, login, and use of the TranGPT website, client applications, and related services (collectively, "the Service"). Please read this Agreement carefully before using the Service, especially the clauses that limit or exclude liability. By registering, logging in, or otherwise using the Service, you acknowledge that you have read, understood, and agreed to be bound by this Agreement in full.',
    sections: [
      {
        title: '1. Acceptance and Scope',
        content:
          '1.1 This Agreement applies to your use of all features and pages of the TranGPT Service.\n1.2 We may revise this Agreement from time to time based on changes in law or business needs. The revised Agreement will take effect once published on this page, without further individual notice. Continued use of the Service after such changes constitutes your acceptance of the revised Agreement.\n1.3 If you do not agree to any part of this Agreement, please stop using the Service and close your account immediately.',
      },
      {
        title: '2. Description of the Service',
        content:
          '2.1 TranGPT is an AI-powered Software-as-a-Service (SaaS) platform that provides multilingual text translation, document translation, text-to-speech (TTS) synthesis, and related API access.\n2.2 We use commercially reasonable efforts to keep the Service stable and accurate; however, due to the inherent limitations of AI translation technology, translation output may contain errors, and we make no guarantee of absolute accuracy.\n2.3 We reserve the right to adjust, add, or discontinue features of the Service based on product planning, technical upgrades, or business needs.',
      },
      {
        title: '3. Account Registration and Security',
        content:
          '3.1 You must provide true, accurate, and complete information (such as your email address) when registering, and update it promptly if it changes.\n3.2 You are responsible for safeguarding your account and password. You bear the resulting liability and losses if your account is used by others or your information is disclosed due to inadequate safekeeping on your part.\n3.3 If you become aware of any unauthorized use of your account, please notify us immediately so we can take appropriate action.\n3.4 Each account is for your own use only. You may not transfer, lease, or otherwise permit others to use your account without our prior written consent.',
      },
      {
        title: '4. User Conduct',
        content:
          '4.1 You agree not to use the Service for any activity that violates applicable laws, regulations, or international conventions, including uploading, translating, or distributing unlawful, infringing, obscene, violent, or fraudulent content.\n4.2 You may not use the Service to conduct network attacks, malicious registrations, bulk scraping, or any activity that disrupts the normal operation of the Service.\n4.3 You are responsible for the legality of content uploaded, translated, or generated through the Service. We reserve the right to remove or block content that violates this Agreement or applicable law, and to suspend or terminate the Service for serious violations.',
      },
      {
        title: '5. Intellectual Property',
        content:
          '5.1 All software, technology, page design, trademarks, and logos related to the Service are owned by Mohist AI Limited or its licensors and are protected by law.\n5.2 You retain ownership of the original text and documents you upload. Translation results generated through the Service may be used for your own lawful purposes, provided you comply with this Agreement.\n5.3 No party may copy, modify, distribute, reverse engineer, or decompile the Service for commercial purposes without our prior written consent.',
      },
      {
        title: '6. Fees and Subscriptions',
        content:
          '6.1 The Service may include free quotas and paid subscription plans. Pricing, billing methods, and entitlements are as stated on the subscription or purchase page.\n6.2 Except as required by law or otherwise promised by us, fees already paid are generally non-refundable; specific refund terms are subject to the purchase page or separate agreement between the parties.\n6.3 We may adjust pricing or plan details based on market conditions and will notify you via website announcement or other reasonable means before such changes take effect.',
      },
      {
        title: '7. Disclaimer and Limitation of Liability',
        content:
          '7.1 The Service is provided "as is". We do not guarantee that the Service will be uninterrupted, timely, secure, or error-free.\n7.2 We are not liable for service interruptions or data loss caused by force majeure events (including natural disasters, government actions, network operator failures, or cyberattacks), though we will make reasonable efforts to minimize resulting harm.\n7.3 To the fullest extent permitted by law, we are not liable for any indirect, incidental, special, or punitive damages arising from your use of, or inability to use, the Service.',
      },
      {
        title: '8. Suspension and Termination',
        content:
          '8.1 If you violate this Agreement, we may, depending on the severity of the violation, warn you, restrict features, suspend the Service, or terminate the Service and close your account.\n8.2 You may request account closure at any time via your account center or by contacting customer support. After closure, we will handle your data in accordance with our Privacy Policy, except as otherwise required by law.',
      },
      {
        title: '9. Amendments to this Agreement',
        content:
          'We reserve the right to amend this Agreement as necessary. The amended Agreement will be published on this page along with an updated date. Continued use of the Service after such updates constitutes acceptance of the amended Agreement.',
      },
      {
        title: '10. Governing Law and Dispute Resolution',
        content:
          '10.1 This Agreement is governed by the laws of the Hong Kong Special Administrative Region of the People\'s Republic of China, without regard to its conflict of law principles.\n10.2 Any dispute arising from this Agreement shall first be resolved through friendly negotiation; if negotiation fails, either party may submit the dispute to a court of competent jurisdiction.',
      },
      {
        title: '11. Contact Us',
        content:
          'If you have any questions, comments, or suggestions regarding this Agreement, please contact us at contact@trangpt.ai and we will respond as soon as possible.',
      },
    ],
  },
  privacy: {
    pageTitle: 'Privacy Policy',
    updatedAt: 'Last updated: September 8, 2026',
    intro:
      'Mohist AI Limited ("we", "us") takes your privacy and personal data protection seriously. This Privacy Policy explains how we collect, use, store, share, and protect your personal information when you register for, log in to, or use TranGPT (collectively, "the Service"), as well as the rights available to you. Please read this Privacy Policy carefully before using the Service.',
    sections: [
      {
        title: '1. Information We Collect',
        content:
          '1.1 Account information: when you register or log in, we collect your email address, password (stored encrypted), and verification records.\n1.2 Business information: information you voluntarily provide during registration or use, such as team size, contact details (e.g. Telegram, WhatsApp, WeChat), and invitation codes, used to provide tailored product and service support.\n1.3 Usage data: text and documents you submit for translation, and the translation or speech output generated, used to provide the translation and TTS services.\n1.4 Device and log information: access time, IP address, browser type, operating system, and access paths, used to safeguard service security, troubleshoot issues, and improve the product experience.',
      },
      {
        title: '2. How We Use Information',
        content:
          '2.1 To create and manage your account, verify your identity, and provide core functions such as login and password recovery.\n2.2 To provide, maintain, and improve the translation, text-to-speech, and API features of the Service.\n2.3 To send you service-related notifications, such as verification codes, account security alerts, and service change notices.\n2.4 With your consent or as permitted by law, for product improvement, statistical analysis, and marketing purposes.\n2.5 We will not use your information for purposes beyond those described in this Policy without obtaining your renewed consent.',
      },
      {
        title: '3. Sharing, Transfer, and Disclosure',
        content:
          '3.1 We do not sell your personal information to any third party.\n3.2 We may share necessary information with partners who provide us with cloud storage, payment processing, SMS/email delivery, or customer support services. These partners may only process your information to the extent necessary to provide such services and must comply with corresponding confidentiality obligations.\n3.3 We may disclose your information as required by law, upon lawful request from judicial or administrative authorities, or to protect the legitimate rights of us, our users, or the public.\n3.4 In the event of a merger, acquisition, or asset transfer, your information may be transferred as part of the transaction, and we will require the new holder to continue to comply with this Privacy Policy.',
      },
      {
        title: '4. Data Storage and Security',
        content:
          '4.1 We adopt industry-standard security measures, including encrypted password storage, encrypted transmission, and access controls, to protect your personal information from unauthorized access, disclosure, alteration, or destruction.\n4.2 We retain your personal information only for as long as necessary to fulfill the purposes described in this Policy, after which it will be deleted or anonymized, except as otherwise required by law.\n4.3 Despite these measures, please understand that no method of transmission over the internet is 100% secure; we will make every reasonable effort to protect your information.',
      },
      {
        title: '5. Cookies and Similar Technologies',
        content:
          'To provide a better experience, we may use cookies and similar technologies to remember your language preference, login state, and to analyze site usage. You may manage or clear cookies through your browser settings, though doing so may affect certain features of the Service.',
      },
      {
        title: '6. Your Rights',
        content:
          '6.1 You have the right to access and correct the personal information we hold about you.\n6.2 You have the right to request deletion of your personal information or closure of your account, except as otherwise required by law.\n6.3 You may manage your account information through the account center, or contact us using the details in this Policy to exercise the above rights; we will respond within a reasonable time.',
      },
      {
        title: '7. Protection of Minors',
        content:
          'The Service is primarily intended for adult users and business customers. If you are a minor, please read this Policy and use the Service under the guidance of a parent or guardian. If we become aware that we have collected personal information from a minor without appropriate consent, we will take steps to delete such information promptly.',
      },
      {
        title: '8. Changes to this Privacy Policy',
        content:
          'We may update this Privacy Policy from time to time. Any changes will be announced by publishing the updated version on this page. Continued use of the Service after such updates constitutes your acceptance of the revised Policy.',
      },
      {
        title: '9. Contact Us',
        content:
          'If you have any questions, comments, or complaints regarding this Privacy Policy or the handling of your personal information, please contact us at contact@trangpt.ai and we will review and respond within a reasonable time.',
      },
    ],
  }
}
